module.exports = {
  latlng: [53.54918, 9.96397],
  zoom: 14,
  title: 'Hamburg als Häusermeer',
  introtext:'Hamburg ohne Straßen, ohne Grünflächen und ohne Wasser - sondern nur als Häusermeer. Können Sie die Orte trotzdem auf der Karte erkennen? Ordnen Sie den Ausschnitten die richtige Antwort zu. Wir geben jeweils einen kleinen Tipp.',
  resultSentences: [
    'Sie haben höchstens mal kurz mit dem Kreuzfahrtschiff angelegt.',
    'Tourist? Beruflich unterwegs? Sie leben bestimmt nicht in Hamburg.',
    'Immerhin kennen Sie ein paar Ecken in Hamburg.',
    'Nicht schlecht. Sie kennen sich halbwegs in Hamburg aus.',
    'Wow! Sie sind wirklich ein Hamburger Jung oder Deern.'
  ],
  questions: [
    {
      id: 'HH 1',
      lat: 53.53847,
      lng: 9.83123,
      zoom: 13,
      answers: [
        'Airbus-Werk Finkenwerder',
        'Bauhaus am Nedderfeld',
        'Alstertal Einkaufszentrum'
      ],
      correctAnswer: 'Airbus-Werk Finkenwerder',
      description: 'Dieses "Bau- und Einkaufszentrum" zieht Kunden aus den Emiraten an.'
    },
    {
      id: 'HH 2',
      lat: 53.559483,
      lng: 9.882395,
      zoom: 16,
      answers: [
        'Waitzstraße',
        'Blankeneser Hauptstraße',
        'Ottenser Hauptstraße'
      ],
      correctAnswer: 'Waitzstraße',
      description: 'Hier im Hamburger Westen wird es beim Einparken manchmal schräg.'
    },
    {
      id: 'HH 3',
      lat: 53.58171,
      lng: 9.9887,
      zoom: 15,
      answers: [
        'Klosterstern',
        'Am Anglo-German-Club',
        'Am Rondeelteich'
      ],
      correctAnswer: 'Klosterstern',
      description: 'Hier geht’s rund – und die Alster ist nicht weit weg.'
    },
    {
      id: 'HH 4',
      lat: 53.580547,
      lng: 10.04151,
      zoom: 15,
      answers: [
        'Barmbeker Markt',
        'Mundsburg',
        'Wiesendamm Ecke Saarlandstraße'
      ],
      correctAnswer: 'Barmbeker Markt',
      description: 'Wichtige Verkehrsachsen, eine U-Bahn: Hier kommt viel zusammen.'
    },
    {
      id: 'HH 5',
      lat: 53.460025,
      lng: 9.982073,
      zoom: 15,
      answers: [
        'Harburg-Zentrum',
        'Bahnhof Altona',
        'Bergedorf-Zentrum'
      ],
      correctAnswer: 'Harburg-Zentrum',
      description: 'Ein Einkaufszentrum, eine Art Ringstraße, und der Hafen so nah …'
    },
    {
      id: 'HH 6',
      lat: 53.488758,
      lng: 10.213305,
      zoom: 16,
      answers: [
        'Bergedorfer Schloss/Sachsentor',
        'Schloßstraße in Wandsbek',
        'Elbschloss-Brauerei'
      ],
      correctAnswer: 'Bergedorfer Schloss/Sachsentor',
      description: 'Wo dieses Schloss steht, ist auch das Wasser nicht weit.'
    },
    {
      id: 'HH 7',
      lat: 53.544027,
      lng: 9.96725,
      zoom: 15,
      answers: [
        'Landungsbrücken',
        'Am Autobahnkreuz der A1',
        'Weg über die Tarpenbek'
      ],
      correctAnswer: 'Landungsbrücken',
      description: 'Von hier aus führt ein unsichtbarer Weg direkt zum Südufer.'
    },
    {
      id: 'HH 8',
      lat: 53.555084,
      lng: 9.968914,
      zoom: 15,
      answers: [
        'Millerntor-Stadion',
        'Volksparkstadion',
        'Sporthalle Alsterdorf'
      ],
      correctAnswer: 'Millerntor-Stadion',
      description: 'Der Sport hier ist oft leider nur zweitklassig …'
    },
    {
      id: 'HH 9',
      lat: 53.61301,
      lng: 10.05953,
      zoom: 14,
      answers: [
        'Steilshoop',
        'Wandsbek-Gartenstadt',
        'Osdorfer Born'
      ],
      correctAnswer: 'Steilshoop',
      description: 'Diese Siedlung setzte einst Maßstäbe im Wohnungsbau.'
    },
    {
      id: 'HH 10',
      lat: 53.573188,
      lng: 9.991178,
      zoom: 15,
      answers: [
        'Stadion am Rothenbaum',
        'Spielbudenplatz',
        'Jahnkampfbahn'
      ],
      correctAnswer: 'Stadion am Rothenbaum',
      description: 'Auf diesem Platz muss man immer wieder mit Schlägern rechnen.'
    },
     {
      id: 'HH 11',
      lat: 53.54968,
      lng: 9.961811,
      zoom: 16,
      answers: [
        'Reeperbahn Ecke Davidstraße',
        'Am U-Bahnhof Mönckebergstraße',
        'Beim Grünen Jäger'
      ],
      correctAnswer: 'Reeperbahn Ecke Davidstraße',
      description: 'Hier gibt es Currywurst unter riesiger Leuchtreklame - bestens bewacht.'
    },
     {
      id: 'HH 12',
      lat: 53.603773,
      lng: 10.024442,
      zoom: 14,
      answers: [
        'City Nord',
        'Hafencity',
        'Energie-Campus Hamburg'
      ],
      correctAnswer: 'City Nord',
      description: 'In der "Bürostadt im Grünen" stehen etliche markante Firmen-Gebäude.'
    }
  ]
}